module.exports = __webpack_public_path__ + "static/media/grey-tr-1.e38e42ea.svg";